import type { Component } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers.ts'

import { DOCTYPES } from '@/constants/doctypes.ts'
import {
  HAS_DETAIL_VIEW_ONE_PERMISSION_OF,
  HAS_LIST_VIEW_ONE_PERMISSION_OF,
} from '@/constants/permissions.ts'

const routeInboxHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/viewsExternal/inbox/InboxView.vue')
  },
  meta: {
    doctypes: {
      [DOCTYPES.COMMUNICATION]: HAS_LIST_VIEW_ONE_PERMISSION_OF,
    },
  },
  name: 'inbox',
  path: '',
}

const routeInboxDetail: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/viewsExternal/inbox/ViewInbox.vue')
  },
  meta: {
    doctypes: {
      [DOCTYPES.COMMUNICATION]: HAS_DETAIL_VIEW_ONE_PERMISSION_OF,
    },
  },
  name: 'inbox-detail',
  path: ':id',
}

const routeInboxRoot: RouteRecordRaw = {
  children: [routeInboxHome, routeInboxDetail],
  path: 'inbox',
}

const redirectInboxDetail: RedirectRouteRelative = {
  name: routeInboxDetail.name,
}

const routeOutboxHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/viewsExternal/outbox/OutboxView.vue')
  },
  meta: {
    doctypes: {
      [DOCTYPES.COMMUNICATION]: HAS_LIST_VIEW_ONE_PERMISSION_OF,
    },
  },
  name: 'outbox',
  path: '',
}

const routeOutboxDetail: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/viewsExternal/outbox/ViewOutbox.vue')
  },
  meta: {
    doctypes: {
      [DOCTYPES.COMMUNICATION]: HAS_DETAIL_VIEW_ONE_PERMISSION_OF,
    },
  },
  name: 'outbox-detail',
  path: ':id',
}

const routeOutboxRoot: RouteRecordRaw = {
  children: [routeOutboxHome, routeOutboxDetail],
  path: 'outbox',
}

const redirectOutboxDetail: RedirectRouteRelative = {
  name: routeOutboxDetail.name,
}

export {
  redirectInboxDetail,
  redirectOutboxDetail,
  routeInboxDetail,
  routeInboxHome,
  routeInboxRoot,
  routeOutboxDetail,
  routeOutboxHome,
  routeOutboxRoot,
}
